import { ScheduleGridHeaderCellProps } from "components/ScheduleGrid/ScheduleGrid.Types";

const AccountingScheduleLeftHeaderCell = (
  props: ScheduleGridHeaderCellProps
) => {
  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        ...props.style,
        ...props.styles,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px 8px",
        backgroundColor: "#f8f9fa",
        borderRadius: "4px",
        minHeight: "50px",
      }}
    >
      <div
        style={{
          fontWeight: "700",
          color: "#424242",
          textAlign: "center",
          fontSize: "13px",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        Due Date
      </div>
    </div>
  );
};

export default AccountingScheduleLeftHeaderCell;
